interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-vaseline-navy to-vaseline-blue flex items-center justify-center p-4">
      <div className="relative">
        {/* Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-[-50%] left-[-50%] w-64 h-64 bg-vaseline-pink/50 rounded-full filter blur-3xl animate-float" />
          <div className="absolute bottom-[-50%] right-[-50%] w-72 h-72 bg-vaseline-blue/50 rounded-full filter blur-3xl animate-float2" />
        </div>

        <div className="text-2xl text-white text-center relative z-10 bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-lg">
          <p className="mb-6">{error}</p>
          <button 
            onClick={onRetry} 
            className="px-6 py-3 bg-vaseline-pink text-white rounded-lg hover:bg-opacity-90 transition-colors
                     shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
}